import { Component } from '@angular/core';
import { MatDialog, MatDialogActions, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { SystemAlertService } from 'src/app/external-user/inventory/services/system-alert.service';
import { SystemAlert } from '../../models/system-alert';
import { ToastService } from 'src/app/shared/services/toast.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastPanelType } from 'src/app/config/app-constants';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-create-ack-dialog',
    templateUrl: './create-ack-dialog.component.html',
    styleUrls: ['./create-ack-dialog.component.scss'],
    imports: [ FormsModule, MatFormField, MatLabel, MatSelect, 
      MatOption, MatDialogActions, MatDialogTitle, MatInputModule ],
    standalone: true
})
export class CreateAckDialogComponent {
  public alert: SystemAlert;

  public ackType: string = null;
  public details: string = "";

  private changeMade: boolean = false;
  
  constructor(
    public dialogRef: MatDialogRef<CreateAckDialogComponent>,
    public dialog: MatDialog,
    public systemAlertService: SystemAlertService,
    private readonly toastService: ToastService,
    private readonly ngxLoader: NgxUiLoaderService
  ) { }

  onDoneClicked(): void {
    const loadingKey = 'CreateAcknowledgement';
    if (this.ackType == null) {
      this.toastService.openToast("Ack type must be selected", ToastPanelType.error);
      return;
    }
    
    this.ngxLoader.start(loadingKey);
    this.systemAlertService.createAcknowledgement(this.alert.id, this.ackType, this.details).subscribe({
      next: () => { 
        this.toastService.openToast("Ack submitted"); 
        this.changeMade = true;
        this.dialogRef.close(this.changeMade); 
        this.ngxLoader.stop(loadingKey);
      },
      error: (error) => { 
        this.toastService.stopLoadingAndShowError("Could not submit ack:", error.message); 
        this.ngxLoader.stop(loadingKey);
      }
    });
  }

  onCancelClicked(): void { this.dialogRef.close(false); }
}
